import {take, put} from 'redux-saga/effects';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as saosActionTypes from '../saosActionTypes';

/**
 * Update SAOS service provider flow
 */
const updateSAOSServiceProviderFlow = function* updateSAOSServiceProviderFlow() {
    while (true) {
        const {payload} = yield take(saosActionTypes.SUBMIT_SAOS_SERVICE_PROVIDER_FORM);
        const {serviceAssignmentLineNo, serviceCaseId, serviceAssignmentData} = payload;

        yield* updateServiceAssignment({
            caller: saosActionTypes.SUBMIT_SAOS_SERVICE_PROVIDER_FORM,
            assignmentType: efServiceAssignmentTypes.OTHER_SERVICES,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: saosActionTypes.SUBMIT_SAOS_SERVICE_PROVIDER_FORM},
        });
    }
};

export default updateSAOSServiceProviderFlow;
